import HttpService from "@core/services/http/http.service";
import { Author, GetListResponse } from "@app/types";
import { Signal } from "@core/services/http/http.type";

class _AuthorService {
  public getList(
    signal?: Signal,
    isShowLoading?: boolean,
    queryParams?: { keyword?: string; sortType?: string }
  ) {
    return HttpService.get<GetListResponse<Author>>("/admin/api/v2/author", {
      signal,
      isShowLoading,
      queryParams: { ...queryParams },
    });
  }
}

const AuthorService = new _AuthorService();

export default AuthorService;
